export default "__VITE_ASSET__DvgOibx5__"